import script from "./PollutionMap2.vue?vue&type=script&setup=true&lang=js"
export * from "./PollutionMap2.vue?vue&type=script&setup=true&lang=js"

import "./PollutionMap2.vue?vue&type=style&index=0&id=9f173aae&lang=css"

const __exports__ = script;

export default __exports__